import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

const Banner1 = () => {
  const [banref, banView] = useInView();

  return (
    <div className="flex flex-col w-full overflow-x-hidden" ref={banref}>
      <motion.div
        initial={{ x: "-100vw" }}
        animate={{ x: banView ? 0 : "-100vw" }}
        transition={{ duration: 2 }}
        className="flex flex-col md:flex-row m-8 mb-3 shadow-slate-95000 shadow-md bg-[#171719]"
      >
        <img
          className="sm:w-[60%] sm:self-center mt-8 md:mr-16 md:w-[40%] object-contain"
          src={require("../../assets/images/28mmflipCap.png")}
          alt="28mmflipCap"
        />
        <div className="flex flex-col self-center m-8">
          <div className="text-5xl font-normal font-HNthin py-5 self-center md:self-start text-white opacity-90">
            Bottle caps
          </div>
          <div className="font-HNmed text-[#9F9F9F] md:mr-24 self-center md:self-start md:text-left">
            We are delighted to present our exclusive bottle cap customization
            service, scrupulously crafted to accommodate a versatile range of
            containers.Each cap is a manifestation of our steadfast dedication
            to superior quality, formidable durability, and our pledge to
            environmental sustainability
          </div>
        </div>
      </motion.div>
      <div className="flex flex-col md:flex-row w-full lg:max-h-[22vw]">
        <motion.div
          initial={{ x: "-40vw" }}
          animate={{ x: banView ? 0 : "-40vw" }}
          transition={{ duration: 2 }}
          className="md:w-4/6 flex flex-col md:flex-row m-8 mt-0 shadow-slate-95000 shadow-md bg-[#171719] md:mr-2"
        >
          <img
            className="sm:w-[60%] sm:self-center md:mr-16 md:w-[23%] object-fill md:absolute md:top-100"
            src={require("../../assets/images/30mmflipCap.png")}
            alt="28mmflipCap"
          />
          <div className="flex flex-col self-center m-8 md:ml-[33%]">
            <div className="text-5xl font-normal font-HNthin py-5 md:text-left self-center md:self-start text-white opacity-90">
              Bottle caps with custom printing
            </div>
            <div className="font-HNmed text-[#9F9F9F] md:mr-24 self-center md:self-start md:text-left">
              Our distinguished clients are privileged to select from a copious
              variety of colors, dimensions, and elaborate designs, or the
              opportunity to augment the singularity by incorporating their
              distinctive logo or imagery.
            </div>
          </div>
        </motion.div>
        <motion.div
          initial={{ x: "100vw" }}
          animate={{ x: banView ? 0 : "100vw" }}
          transition={{ duration: 2 }}
          className="md:relative w-full md:w-2/6 flex flex-col md:flex-row m-8 ml-2 mt-0 shadow-slate-95000 shadow-md bg-[#171719] items-center md:items-start"
        >
          <img
            className="w-[60%] sm:self-center md:w-[30%] object-fill md:relative md:top-[30%] max-w-[30%] mx-uato"
            src={require("../../assets/images/viewDetails.png")}
            alt="28mmflipCap"
          />
          <img
            className="w-[60%] sm:self-center md:w-[90%] object-cover md:relative md:top-[-18%] md:left-[-30%]"
            src={require("../../assets/images/20ltrcap2.png")}
            alt="28mmflipCap"
          />
        </motion.div>
      </div>
    </div>
  );
};
export default Banner1;
